import { useState, useRef, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { RESET_DEVICE_AUTH_ERROR } from '../../../actions/actionTypes';

const usePINInput = (length, onComplete) => {
  const [inputs, setInputs] = useState(Array(length).fill(''));
  const inputRefs = useRef([]);
  const dispatch = useDispatch();

  useEffect(() => {
    onComplete(inputs.join(''));
  }, [inputs, onComplete]);

  const handleChange = useCallback(
    (index, value) => {
      // 全角数字を半角に変換し、数字以外の文字を削除
      const newValue = value
        .replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 0xfee0))
        .replace(/[^0-9]/g, '');

      if (inputs[index] !== newValue && newValue.length <= 1) {
        const newInputs = [...inputs];
        newInputs[index] = newValue;
        setInputs(newInputs);

        // 次の入力フィールドにフォーカスを移動
        if (newValue && index < length - 1) {
          inputRefs.current[index + 1].focus();
        }
      }
    },
    [inputs, length],
  );

  // Backspaceキーが押された場合、前の入力フィールドにフォーカスを移動
  const handleKeyDown = useCallback(
    (event, index) => {
      if (event.key === 'Backspace' && inputs[index] === '' && index > 0) {
        inputRefs.current[index - 1].focus();
      }
    },
    [inputs],
  );

  // フォーカスが当たった場合、エラーステータスをリセット
  const handleFocus = useCallback(() => {
    dispatch({ type: RESET_DEVICE_AUTH_ERROR });
  }, [dispatch]);

  return { inputs, handleChange, handleKeyDown, handleFocus, inputRefs };
};

export default usePINInput;
